"use client";
import React__default, { useState, useMemo } from 'react';

const MenuItemVisibleContext = React__default.createContext({
    item: undefined,
    setItem: () => { },
});
function MenuItemVisibleProvider(props) {
    const { value, children } = props;
    const [item, setItem] = useState(value);
    const providerValue = useMemo(() => ({ item, setItem }), [item, setItem]);
    return React__default.createElement(MenuItemVisibleContext.Provider, { value: providerValue }, children);
}

export { MenuItemVisibleContext, MenuItemVisibleProvider };
//# sourceMappingURL=MenuItemVisibleProvider.js.map
